import { type Ref, ref, computed } from "vue";
import apiSkobo from "@/helpers/api/apiSkobo";

export const useRelationsComposable = () => {
  const userRelations: Ref<Record<string, unknown>> = ref({});

  const reloadUsersRelations = async (userId: string) => {
    const response = await apiSkobo.get(`/appconfidentialfolder/userrelations/${userId}`);

    const clone = JSON.parse(JSON.stringify(userRelations.value));
    clone[userId] = response.data;
    userRelations.value = clone;
  };

  const loadUsersRelations = async (userId: string) => {
    if (userRelations.value[userId]) {
      return;
    }
    await reloadUsersRelations(userId);
  };

  const usersRelations = computed(() => (userId: string) => {
    return userRelations.value[userId];
  });

  return {
    userRelations,
    loadUsersRelations,
    reloadUsersRelations,
    usersRelations
  };
};
